import { ViewModel,View } from "binder"
import { getAsNumber } from "src/uicomponents/components/utilities";
import { IExecutablePart, IExecutablePartVisitor } from "../executablePart";
import  { CreatePaginationInfoView } from "./createPaginationInfo-view"

export class CreatePaginationInfoViewModel extends ViewModel implements IExecutablePart{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new CreatePaginationInfoView();
    }
    public getTypeId(): string {
        return "VM-FF010AA9-29A0-4AB1-BDD9-88A7D560F1C7"
    }

    public set isStatic(v: boolean) { 
        this._isStatic = v;
        this.currentPage = this.getAsNumberIfNotStatic(this.currentPage);
        this.totalPages = this.getAsNumberIfNotStatic(this.totalPages);
    } public get isStatic(): boolean { return this._isStatic;} private _isStatic: boolean;
    public set currentPage(v: any) { this._currentPage = this.getAsNumberIfNotStatic(v); } public get currentPage(): any { return this._currentPage;} private _currentPage: any;
    public set totalPages(v: any) { this._totalPages = this.getAsNumberIfNotStatic(v); } public get totalPages(): any { return this._totalPages;} private _totalPages: any;
    public set resultName(v: string) { this._resultName = v; } public get resultName(): string { return this._resultName;} private _resultName: string;

    private getAsNumberIfNotStatic(v){
        if(this.isStatic==true){
            return getAsNumber(v);
        }else{
            return v;
        }
    }

    accept(visitor: IExecutablePartVisitor, parameter: any) {
        return visitor.VisitCreatePaginationInfo(this,parameter);
    }

}
